import React from 'react';
import creditflowresearchConfig from '@creditflowresearch/config';
import finsightConfig from '@finsight/config';

import TenantConfig from '@framework/tenant/TenantConfig';

import SuccessOverlay from './SuccessOverlay';
import Animation from '@creditflowresearch/uilib/Animation';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import Modal from '@creditflowresearch/uilib/Modal';
import { LogoFinsightStandart } from '@creditflowresearch/uilib/Logo/Finsight/Standart';
import { LogoCreditFlowResearchStandart } from '@creditflowresearch/uilib/Logo/CreditFlowResearch/Standart';
import { ColorType } from '@creditflowresearch/uilib/Logo/types';

import styles from './finsightModal.module.scss';

interface IFinsightModalProps {
  children: React.ReactNode,
  modalTitle: string | React.ReactNode,
  dataTest: string,
  isFetching: boolean,
  isVisible: boolean,
  isSuccessOverlay?: boolean,
  successText?: string,
  isSubmitSucceed?: boolean,
  hideOnOverlayClicked?: boolean,
  onCloseClicked: () => void,
}

const logoMapping = {
  [finsightConfig.code]: LogoFinsightStandart,
  [creditflowresearchConfig.code]: LogoCreditFlowResearchStandart,
};

const WAVE_PARAMS = {
  factor: 0.018,
  variation: 0.004,
  amplitude: 140,
  lines: 26,
  waveColor: { r: 255, g: 255, b: 255, a: 0.1 },
  lineStroke: 1,
  speed: 0.0008,
};

const FinsightModal = ({
  isFetching,
  modalTitle,
  children,
  successText,
  isSubmitSucceed,
  onCloseClicked,
  isVisible,
  isSuccessOverlay = true,
  ...otherProps
}: IFinsightModalProps) => {
  if (!isVisible) {
    return null;
  }

  const tenantCode = TenantConfig.fromHostname().code;

  const LogoComponent = logoMapping[tenantCode] ?? LogoFinsightStandart;
  return (
    <Modal
      usePortal
      className={ styles.modalWrp }
      onCloseClicked={ onCloseClicked }
      isVisible={ isVisible }
      { ...otherProps }
    >
      <div className={ styles.modalLeftSide }>
        <Animation parameters={ WAVE_PARAMS } />
        <div className={ styles.logo }>
          <LogoComponent
            colorType={ ColorType.WHITE }
          />
        </div>
        <div className={ styles.centerContainer }>
          <div className={ styles.centeredText }>
            { modalTitle }
          </div>
        </div>
        <div className={ styles.bottomText }>
          <p>Better Tools.</p>
          <p>Better Execution.</p>
        </div>
      </div>
      <div className={ styles.modalRightSide }>
        <Spinner
          isVisible={ isFetching }
          overlay
        />
        <div className={ styles.modalDescriptionContainer }>
          { children }
          {
            isSuccessOverlay && (
              <SuccessOverlay
                successText={ successText }
                isSubmitSucceed={ isSubmitSucceed }
                onCloseModalClick={ onCloseClicked }
              />
            )
          }
        </div>
      </div>
    </Modal>
  );
};

export default FinsightModal;
